var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-modal-dialog',{staticClass:"md-dialog",on:{"md-opened":function($event){_vm.event = 'md-opened'}}},[_c('ModalWrapper',[_c('RegionsFilter',{on:{"close":_vm.onModalClose}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }